module.exports = __webpack_public_path__ + "static/media/AR.d2c1f8d2.svg";